var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgEmptyChat = function SvgEmptyChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 139.338,
    height: 138.35
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "empty-chat_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Subtraction 114",
    d: "M21.424 95.732a2.192 2.192 0 01-2.124-2.614l2.884-15.046-2.241-.442a7 7 0 00-.355-4.925L6.736 44.753a6.788 6.788 0 00-6.116-3.99c-.207 0-.415.01-.62.03L6.009 9.452A11.576 11.576 0 0117.309 0a11.422 11.422 0 012.2.216l67.84 13.37a11.685 11.685 0 019.11 13.691l-9.888 51.587a11.576 11.576 0 01-11.3 9.45 11.409 11.409 0 01-2.2-.216l-25.44-5.013-25.288 12.434a2.1 2.1 0 01-.919.213z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "No Chat"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4478"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4477"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4476"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon awesome-comment-alt",
    d: "M36.647 53.716l-25.905 12.08a4.768 4.768 0 00-2.305 6.33l10.41 22.487a4.768 4.768 0 006.33 2.305l5.512-1.501 14.76.826-4.08-6.875 9.714-4.53a4.768 4.768 0 002.304-6.33L42.977 56.02a4.768 4.768 0 00-6.33-2.304z",
    fill: "#e7e7e7"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon awesome-comment-alt",
    d: "M36.054 53.874L6.859 67.488a5.374 5.374 0 00-2.597 7.135l10.21 21.896a5.374 5.374 0 007.136 2.599l7.299-3.403 17.011.804-6.066-5.911L50.8 85.502a5.374 5.374 0 002.597-7.135l-10.21-21.895a5.374 5.374 0 00-7.133-2.598z",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#757575",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Mask Group 49",
    transform: "translate(42.662 5.633)",
    clipPath: "url(#empty-chat_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4475"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon awesome-comment-alt",
    d: "M82.32 20.544L30.318 10.436a8.838 8.838 0 00-10.352 6.982l-8.89 45.058A8.838 8.838 0 0018.06 72.83l13 2.527-2.21 11.375a1.659 1.659 0 002.33 1.816l19.382-9.4 19.501 3.79a8.838 8.838 0 0010.353-6.983l8.888-45.058a8.838 8.838 0 00-6.982-10.352z",
    fill: "#e7e7e7"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon awesome-comment-alt",
    d: "M81.258 20.137L22.651 8.745a9.96 9.96 0 00-11.667 7.87L2.44 60.57a9.96 9.96 0 007.87 11.666l14.651 2.848-2.492 12.82a1.87 1.87 0 002.628 2.047l21.842-10.596 21.978 4.273a9.96 9.96 0 0011.667-7.87l8.544-43.954a9.96 9.96 0 00-7.87-11.667z",
    fill: "none",
    stroke: "#757575",
    strokeWidth: 3
  })))), /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon weather-stars",
    d: "M14.206 120.926a9.712 9.712 0 003.081-6.794 9.673 9.673 0 00-2.441-7.061 9.673 9.673 0 006.652 3.4 9.807 9.807 0 007.17-2.116A9.794 9.794 0 0026 112.66a10.155 10.155 0 00-.234 5.047 9.937 9.937 0 002.274 4.548 9.722 9.722 0 00-6.666-3.417 9.648 9.648 0 00-7.168 2.087zM100.769 96.454a21.229 21.229 0 006.79 14.827 21.144 21.144 0 0015.151 6.098 21.144 21.144 0 00-15.151 6.1 21.438 21.438 0 00-6.79 14.875 21.409 21.409 0 00-3.28-10.578 22.2 22.2 0 00-7.991-7.622 21.721 21.721 0 00-10.763-2.771 21.251 21.251 0 0015.2-6.1 21.09 21.09 0 006.834-14.829zM117.431 18.071a8.254 8.254 0 001.471-6.168 8.221 8.221 0 00-3.18-5.496 8.221 8.221 0 006.101 1.76 8.336 8.336 0 005.642-2.929 8.324 8.324 0 00-1.53 4.025 8.631 8.631 0 00.623 4.248 8.446 8.446 0 002.635 3.429 8.263 8.263 0 00-6.115-1.772 8.2 8.2 0 00-5.647 2.903z",
    fill: "#bfbfbf"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon weather-stars",
    d: "M16.341 41.792a9.9 9.9 0 003.143-6.928 9.863 9.863 0 00-2.49-7.2 9.863 9.863 0 006.783 3.468 10 10 0 007.314-2.161 9.987 9.987 0 00-2.72 4.391 10.355 10.355 0 00-.238 5.146 10.132 10.132 0 002.319 4.638 9.913 9.913 0 00-6.798-3.485 9.838 9.838 0 00-7.313 2.13z",
    fill: "#bfbfbf"
  }))));
};
export default SvgEmptyChat;